import { render, staticRenderFns } from "./imgComp.vue?vue&type=template&id=42c0b073&scoped=true"
import script from "./imgComp.vue?vue&type=script&lang=js"
export * from "./imgComp.vue?vue&type=script&lang=js"
import style0 from "./imgComp.vue?vue&type=style&index=0&id=42c0b073&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c0b073",
  null
  
)

export default component.exports